import React from 'react'
import { Tooltip } from 'react-tooltip'

type ChartTooltipPlace = 'top' | 'right' | 'bottom' | 'left'

interface ChartTooltipProps {
  id: string
  place: ChartTooltipPlace
  children?: React.ReactNode
  className?: string
}

const ChartTooltip = ({
  id,
  place,
  children,
  className = 'tooth-tooltip',
}: ChartTooltipProps): React.ReactElement => {
  return (
    <Tooltip
      id={id}
      place={place}
      className={className}
      positionStrategy="fixed"
      delayShow={400}
      delayHide={200}
      role="tooltip"
      closeOnScroll={false}
    >
      {children}
    </Tooltip>
  )
}

export default ChartTooltip
